<span *ngFor="let part of parts; let last = last;">
  <span *ngIf="part">{{ part }}{{ last ? '' : ', '}}</span>
</span>
